module.exports = __webpack_public_path__ + "img/illu-card-beschwerden-breath.a591e9da.svg";